import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';

class DefaultLink extends Component {
    render() {
        return (
            <div className="DefaultLink">
                <h4>{this.props.tagNameName}</h4>
                <div className="row">
                    <div className="col-xs-12 col-sm-3">
                        <PresetColorPicker
                            color={this.props.fontData.color}
                            onColorChange={this.props.onDefaultLinkColorChange(this.props.tagName)}
                        />
                        Normal
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        <PresetColorPicker
                            color={this.props.fontData.hoverColor}
                            onColorChange={this.props.onDefaultLinkHoverColorChange(this.props.tagName)}
                        />
                        Hover
                    </div>
                </div>
            </div>
        );
    }
}

DefaultLink.propTypes = {
    tagNameName: PropTypes.string
};

DefaultLink.contextTypes = {
    store: PropTypes.object
};

const mapDispatchToProps = dispatch => {
    return {
        onDefaultLinkColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_DEFAULT_LINK_COLOR,
                    layer: tagName,
                    color: event.target.value
                });
        },
        onDefaultLinkHoverColorChange: tagName => {
            return event =>
                dispatch({
                    type: ActionTypes.THEME_FILTER_BAR_SET_DEFAULT_LINK_HOVER_COLOR,
                    layer: tagName,
                    hoverColor: event.target.value
                });
        }
    };
};

export default connect(null, mapDispatchToProps)(DefaultLink);



// WEBPACK FOOTER //
// ./src/components/pages/theme/filterbar/DefaultLink.js